/**
 * Login Callback Component
 * 
 * To call AuthGaurd Explicitly to use this component
 *  
 * KPE-865
 * 
 * @author Manjit Latthe
 * @copyright 2025
 * @version 1.0.0
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ava-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    // setTimeout(() => {
      this.router.navigateByUrl(`/login`);
    // }, 1000);
  }
}
